<script lang="ts" setup>
import { ref, watch } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { getSportGames } from '~/resources/sports'
import { useSports } from '~/composables/sports/use-sports'
const { playSport, isDropDownNotification } = useSports()
const isDropdownOpen = ref()

watch(
  () => isDropdownOpen.value,
  (menuRef: HTMLElement) => {
    if (menuRef) {
      onClickOutside(isDropdownOpen, () => {
        isDropDownNotification.value = false
      })
    }
  },
  { immediate: true }
)
</script>
<template>
  <div class="sport-betting">
    <div class="sport-betting__ctn-sports">
      <div
        v-for="sport in getSportGames()"
        :key="sport.id"
        class="sport-betting__item"
        :class="[ {'coming-soon': sport.isMaintain || sport.isComingSoon},  sport.alias]"
        @click="playSport(sport)"
      >
        <NuxtImg format="webp" :src="sport.imageUrlMobile" class="banner-sport" :alt="sport.alias" />
        <img
          v-if="sport.isMaintain"
          :src="sport.labelMaintance"
          class="label-icon"
          alt="label maintain"
        />
        <img
          v-if="sport.isComingSoon"
          :src="sport.labelComingSoon"
          class="label-icon"
          alt="label coming soon"
        />
        <img
          v-if="sport.label && !sport.isMaintain && !sport.isComingSoon"
          :src="sport.imgLabel"
          class="label-icon"
          alt="label icon"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~scssAsset/mobile/sports/direct-betting.scss';
</style>
